import CardSystem from '../CardSystem';
import TransformComponent from '../../../Component/Transform';
import CardComponent from '../../../Component/Level/Card';
import StreakTask from '../Task/StreakTask';
import { PlaySound } from '../../Audio/AudioHelper';
import { AudioTrackType } from '../../Audio/AudioClip';
import CardAnimationTask from '../../../Utility/Task/CardAnimationTask';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import StreakBar from '../../../Prototype/UI/Level/StreakBar';
import Point from '../../../Utility/Point';
import RopeComponent from '../../../Component/Render/Rope';
import Connected from '../../../Prototype/Level/Card/Modifier/Connected';
import { Anim, StartAnimationClip } from '../../Animation/AnimationHelper';
import { sleep } from '../../../Utility/async';
import { CardMatch } from '../../Animation/Clip';
import { ConnectedCardMatch } from 'System/Animation/Clip/ConnectedCardMatch';

export default function MatchConnectedCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData,
): void {
    system.disableCardsInputReasons.add('matchConnectedCardAnimationPlaying');
    let streakAudioIndex = system.store.getState().levelState.cardsState
        .matchSequence.length;
    if (streakAudioIndex > 10) streakAudioIndex = 10;

    PlaySound(
        [
            'rising-tones1',
            'rising-tones2',
            'rising-tones3',
            'rising-tones4',
            'rising-tones5',
            'rising-tones6',
            'rising-tones7',
            'rising-tones8',
            'rising-tones9',
            'rising-tones10',
        ][streakAudioIndex - 1]
    );

    StreakBar.instance.update();

    const connectedModifier = system.getCardByID(taskData.cards[0]).getModifier(Connected);
    const ropeComponent = connectedModifier.rope.getComponent(RopeComponent);
    ropeComponent.startFolding();

    taskData.cards.forEach((cardID, i) => {
        const card = system.getCardByID(cardID);

        // Add to cards container to set correct position.
        system.cardsContainer.addChild(card);

        // Set position.
        const cardComponent = card.getComponent(CardComponent);
        card.getComponent(TransformComponent).position.set(
            cardComponent.x,
            cardComponent.y,
        );

        system.stackContainer.addChild(card);
    });

    // trigger rope edge points update
    const transform = system.getCardByID(taskData.cards[0]).getComponent(TransformComponent);
    transform.position.set(transform.x, transform.y);
    system.cardStack.sort();

    StartAnimationClip(new CardMatch(system.getCardByID(taskData.cards[0]), {
        cardScore: taskData.cardScore,
        coinsCollected: taskData.coinsCollected,
        target: Point.Zero,
        isConnectedCard: true,
        delay: 0,
        system,
    }));

    StartAnimationClip(new ConnectedCardMatch(system.getCardByID(taskData.cards[1]), {
        cardScore: taskData.cardScore,
        coinsCollected: taskData.coinsCollected,
        target: Point.Zero,
        delay: 900,
        system,
    }));

    sleep(1900).then(async () => {
        system.disableCardsInputReasons.remove('matchConnectedCardAnimationPlaying');
        await Anim(connectedModifier.rope, { alpha: 0, duration: 200 });
        connectedModifier.rope.destroy();

        taskData.cards.forEach((cardID) => {
            system.getCardByID(cardID).getModifier(Connected).destroy();
        });
    });

    system.taskQueue.queue(new StreakTask());
}
